 /**
 * 操作按钮权限处理
 * 实有房屋 同部门数据权限操作(删除、编辑)
 */

 import store from '@/store'

 export default {
   inserted(el, binding, vnode) {
     const { value } = binding
     const permissions = store.state && store.state.user.userData.deptSysCode
     if (value && permissions) {
       const permissionFlag = value
       const hasPermissions = permissions==permissionFlag
       if (!hasPermissions) {
         el.parentNode && el.parentNode.removeChild(el)
       }
     }else{
        el.parentNode && el.parentNode.removeChild(el)
     }
   }
 }